<template>
    <div class="p-fluid mt-3">
        <h5>Apply To Join</h5>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">No. KTP</label>
            <div class="col-12 md:col-10">
                <InputText id="name" type="text" required v-model="form.id_card_number" :class="{
                    'p-invalid':
                        submitted && !form.id_card_number,
                }" minlength="16"/>
                <small class="p-invalid" v-if="submitted && !form.id_card_number">Nomor KTP Perlu Diisi</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Nama</label>
            <div class="col-12 md:col-10">
                <InputText id="name" type="text" required v-model="form.name" :class="{
                    'p-invalid':
                        submitted && !form.name,
                }" />
                <small class="p-invalid" v-if="submitted && !form.name">Name perlu diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Jenis Kelamin</label>
            <div class="col-12 md:col-10">
                <Dropdown v-model="form.gender" :options="dropdownValues" optionLabel="name" optionValue="code"
                    placeholder="Pilih Jenis Kelamin" :class="{
                        'p-invalid':
                            submitted && !form.gender,
                    }" />
                <small class="p-invalid" v-if="submitted && !form.gender">Gender Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Tempat Lahir</label>
            <div class="col-12 md:col-10">
                <InputText id="name" type="text" required="true" v-model="form.birthplace" :class="{
                    'p-invalid':
                        submitted && !form.birthplace,
                }" />
                <small class="p-invalid" v-if="submitted && !form.birthplace">Tempat Lahir Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Tanggal Lahir</label>
            <div class="col-12 md:col-10">
                <Calendar :showIcon="true" :showButtonBar="true" v-model="form.birthdate" :class="{
                    'p-invalid':
                        submitted && !form.birthdate,
                }">
                </Calendar>
                <small class="p-invalid" v-if="submitted && !form.birthdate">Tanggal Lahir Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Email</label>
            <div class="col-12 md:col-10">
                <InputText id="email3" type="text" name="email" required="true" v-model="form.email" :class="{
                    'p-invalid':
                        submitted && !form.email,
                }" />
                <small class="p-invalid" v-if="submitted && !form.email">Email perlu diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Nomor Telepon</label>
            <div class="col-12 md:col-10">
                <InputText id="phone3" type="text" name="mobile_number" required="true" v-model="form.phone_number"
                    :class="{
                        'p-invalid':
                            submitted && !form.phone_number,
                    }" />
                <small class="p-invalid" v-if="submitted && !form.phone_number">Nomor Telepon Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Alamat Sesuai Domisili</label>
            <div class="col-12 md:col-10">
                <Textarea id="address" name="address" v-model="form.address" required="true" rows="5" cols="50" :class="{
                    'p-invalid':
                        submitted && !form.address,
                }">
                                    </Textarea>
                <small class="p-invalid" v-if="submitted && !form.address">Alamat Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Alamat Sesuai KTP</label>
            <div class="col-12 md:col-10">
                <Textarea id="address" name="address" v-model="form.address_2" required="true" rows="5" cols="50" :class="{
                    'p-invalid':
                        submitted && !form.address_2,
                }">
                                    </Textarea>
                <small class="p-invalid" v-if="submitted && !form.address_2">Alamat Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Pendidikan Terakhir</label>
            <div class="col-12 md:col-10">
                <Dropdown v-model="form.last_education_level" :options="lastEducationLevels" optionLabel="name"
                    optionValue="id" placeholder="Pilih Pendidikan Terakhir" :class="{
                        'p-invalid':
                            submitted &&
                            !form.last_education_level,
                    }" />
                <small class="p-invalid" v-if="
                    submitted &&
                    !form.last_education_level
                ">Pendidikan Terakhir Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Masukkan CV / Resume</label>
            <div class="col-12 md:col-10">
                <FileUpload mode="basic" name="demo[]" accept=".pdf,.doc,.docx" :maxFileSize="300000" @select="onUploadResume"/>
                <small class="p-invalid text-red-500" v-if="
                    submitted &&
                    !form.resume
                ">Resume Perlu Diisi.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="email3" class="col-12 mb-2 md:col-2 md:mb-0">Masukkan Foto</label>
            <div class="col-12 md:col-10">
                <FileUpload mode="basic" name="photo[]" accept=".jpg,.png,.webp" :maxFileSize="300000" @select="onUploadPhoto"/>
                <small class="p-invalid" v-if="
                    submitted &&
                    !form.photo
                ">Photo Perlu Diisi.</small>
            </div>
        </div>
    </div>
</template>
<script>
import { usePage } from "@inertiajs/inertia-vue3";
import axios from 'axios';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';

export default {
    components:{
        Calendar, Dropdown, FileUpload, InputText, Textarea,
    },
    props:['submitted'],
    data(){
        return {
            model: {},
            lastEducationLevels: {},
            dropdownValues: [
                { name: "Laki-Laki", code: "Laki-laki" },
                { name: "Perempuan", code: "Perempuan" },
            ],
            form: {
                vacancies_id: usePage().props.value.vacancy_detail.id,
                name: "",
                gender: "",
                birthplace: "",
                birthdate: "",
                email: "",
                phone_number: "",
                address: "",
                last_education_level: "",
                resume: "",
                photo: "",
            },
        }
    },
    mounted(){
        this.initData();
    },
    methods:{
        initData(){
            this.model = usePage().props.value.vacancy_detail;
            axios.get(this.route("education.levels"))
            .then((data) => {
                this.lastEducationLevels = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error,
                    life: 3000,
                });
            })
        },
        onUploadResume(event) {
            this.form.resume = event.files[0];
            this.$toast.add({
                severity: "info",
                summary: "Success",
                detail: "File Uploaded",
                life: 3000,
            });
        },
        onUploadPhoto(event){
            this.form.photo = event.files[0];
            this.$toast.add({
                severity: "info",
                summary: "Success",
                detail: "Photo Uploaded",
                life: 3000,
            });
        }
    }
}

</script>
